/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : MoreProjectDetails.jsx
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
import { Box } from "@mui/material";
import React from "react";
import PropTypes from "prop-types";
import CustomScrollerTable from "../common/table/CustomScrollerTable";

function MoreProjectDetails({ tableProjectConfigs, renderBeforeZones }) {
  return (
    <div>
      <Box sx={{ px: 1, pt: 0, pb: 1 }}>
        {renderBeforeZones}
        {tableProjectConfigs?.map(
          (table) =>
            (table?.condition === undefined || table?.condition) && (
              <React.Fragment key={table?.key}>
                <CustomScrollerTable
                  title={table?.title}
                  count={table?.count}
                  columns={table?.columns}
                  rows={table?.rows}
                  handleOnClick={() => table.handleOnClick(table?.title)}
                  onlyUsers={table?.onlyUsers}
                  hideAddButton={table?.hideAddButton}
                  actionIcon={table?.actionIcon}
                />
              </React.Fragment>
            )
        )}
      </Box>
    </div>
  );
}

MoreProjectDetails.propTypes = {
  tableProjectConfigs: PropTypes.array,
  renderBeforeZones: PropTypes.node,
};

export default MoreProjectDetails;
